import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null checking · false anon · object

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch (e) {
      if (e?.response?.status === 401) {
        try {
          await api.post("/auth/refresh");
          const { data } = await api.get("/auth/me");
          return setAdmin(data);
        } catch (_) { /* anon */ }
      }
      setAdmin(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdmin(data.admin);
      return data.admin;
    } catch (e) {
      throw new Error(formatApiError(e));
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    setAdmin(false);
  };

  const can = (perm) => !!admin && admin.permissions?.includes(perm);

  return (
    <AdminAuthContext.Provider value={{ admin, login, logout, can, refresh: fetchMe }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
